// TweenLite + ScrollToPlugin
import TweenLite from 'gsap/TweenMax';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

class Footer {

  /**
   * Constructor:
   * Footer constructor called in `manager.js` file.
   *
   * @constructor
   * @param {Object} options - Footer class options
   */
  constructor({ el }) {
    // Root
    this.$root = el;

    // Top
    this.$top = this.$root.querySelector('.site-footer-up');
    this.$top.addEventListener('click', (e) => {
      // Prevent
      e.preventDefault();

      // Get href
      const href = e.currentTarget.getAttribute('href');

      // Scroll to href
      TweenLite.to(window, 1.2, {
        scrollTo: href,
        ease: Expo.easeOut
      });
    });
  }
}

export default Footer;
